/*!
 * jQuery Custom-form-elements plugin
 * Author: Globalia
 * Licensed under the WTFPL license
 */



// Parsley validation
// --------------------------------------------------

( function( $ ) {

    "use strict";
    window.Parsley.setLocale('fr');
    $("[gr-form]").length && $("[gr-form]").parsley({
        trigger:      'change',
        errorClass: "parsley-error",
        classHandler: function (el) {
            return el.$element.closest('.gr-form__field, .gr-form__field--inline, .gr-form__field--icon-after, .gr-form__field--icon-before');
        },
        errorsContainer: function(pEle) {
            var $err = pEle.$element.closest('.gr-form__field, .gr-form__field--inline, .gr-form__field--icon-after, .gr-form__field--icon-before').append();
            return $err;
        }
    });

} )( require('jquery'), require('../../../../node_modules/parsleyjs/dist/parsley.min.js'), require('../../../../node_modules/parsleyjs/dist/i18n/fr.js') );
